import { INTERVIEW_SECTIONS, INTERVIEW_TYPES } from "../types/interviewTypes"
export const sectionsDictionary = [
  {
    title: "Intake",
    sections: [
      {
        title: "Record Management",
        section: INTERVIEW_SECTIONS.RECORD_MGMT,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Demographics",
        section: INTERVIEW_SECTIONS.DEMOGRAPHICS,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Substance Use 1",
        section: INTERVIEW_SECTIONS.SUBSTANCE_USE_1,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Substance Use 2",
        section: INTERVIEW_SECTIONS.SUBSTANCE_USE_2,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Substance Use 3",
        section: INTERVIEW_SECTIONS.SUBSTANCE_USE_3,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Planned Services 1",
        section: INTERVIEW_SECTIONS.PLANNED_SERVICES_1,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Planned Services 2",
        section: INTERVIEW_SECTIONS.PLANNED_SERVICES_2,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Planned Services 3",
        section: INTERVIEW_SECTIONS.PLANNED_SERVICES_3,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Planned Services 4",
        section: INTERVIEW_SECTIONS.PLANNED_SERVICES_4,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Family",
        section: INTERVIEW_SECTIONS.FAMILY,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Education",
        section: INTERVIEW_SECTIONS.EDUCATION,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Legal",
        section: INTERVIEW_SECTIONS.LEGAL,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Mental",
        section: INTERVIEW_SECTIONS.MENTAL,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
      {
        title: "Social",
        section: INTERVIEW_SECTIONS.SOCIAL,
        interviewType: INTERVIEW_TYPES.INTAKE,
      },
    ],
  },
  {
    title: "Follow Up",
    sections: [
      {
        title: "Start Interview",
        section: INTERVIEW_SECTIONS.START_INTERVIEW,
        interviewType: INTERVIEW_TYPES.FOLLOW_UP,
      },
      {
        title: "Substance Use 1",
        section: INTERVIEW_SECTIONS.SUBSTANCE_USE_1,
        interviewType: INTERVIEW_TYPES.FOLLOW_UP,
      },
      {
        title: "Substance Use 2",
        section: INTERVIEW_SECTIONS.SUBSTANCE_USE_2,
        interviewType: INTERVIEW_TYPES.FOLLOW_UP,
      },
      {
        title: "Substance Use 3",
        section: INTERVIEW_SECTIONS.SUBSTANCE_USE_3,
        interviewType: INTERVIEW_TYPES.FOLLOW_UP,
      },
      {
        title: "Family",
        section: INTERVIEW_SECTIONS.FAMILY,
        interviewType: INTERVIEW_TYPES.FOLLOW_UP,
      },
      {
        title: "Education",
        section: INTERVIEW_SECTIONS.EDUCATION,
        interviewType: INTERVIEW_TYPES.FOLLOW_UP,
      },
      {
        title: "Legal",
        section: INTERVIEW_SECTIONS.LEGAL,
        interviewType: INTERVIEW_TYPES.FOLLOW_UP,
      },
      {
        title: "Mental",
        section: INTERVIEW_SECTIONS.MENTAL,
        interviewType: INTERVIEW_TYPES.FOLLOW_UP,
      },
      {
        title: "Social",
        section: INTERVIEW_SECTIONS.SOCIAL,
        interviewType: INTERVIEW_TYPES.FOLLOW_UP,
      },
      {
        title: "Program",
        section: INTERVIEW_SECTIONS.PROGRAM,
        interviewType: INTERVIEW_TYPES.FOLLOW_UP,
      },
      {
        title: "Follow up",
        section: INTERVIEW_SECTIONS.FOLLOW_UP,
        interviewType: INTERVIEW_TYPES.FOLLOW_UP,
      },
    ],
  },
  {
    title: "Discharge",
    sections: [
      {
        title: "Start Interview",
        section: INTERVIEW_SECTIONS.START_INTERVIEW,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Substance Use 1",
        section: INTERVIEW_SECTIONS.SUBSTANCE_USE_1,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Substance Use 2",
        section: INTERVIEW_SECTIONS.SUBSTANCE_USE_2,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Substance Use 3",
        section: INTERVIEW_SECTIONS.SUBSTANCE_USE_3,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Family",
        section: INTERVIEW_SECTIONS.FAMILY,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Education",
        section: INTERVIEW_SECTIONS.EDUCATION,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Legal",
        section: INTERVIEW_SECTIONS.LEGAL,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Mental",
        section: INTERVIEW_SECTIONS.MENTAL,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Social",
        section: INTERVIEW_SECTIONS.SOCIAL,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Program",
        section: INTERVIEW_SECTIONS.PROGRAM,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Discharge",
        section: INTERVIEW_SECTIONS.DISCHARGE,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Services Received 1",
        section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_1,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Services Received 2",
        section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_2,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Services Received 3",
        section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_3,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Services Received 4",
        section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_4,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
      {
        title: "Services Received 5",
        section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_5,
        interviewType: INTERVIEW_TYPES.DISCHARGE,
      },
    ],
  },
]
